import LoginComponent from '../login-component';
import {localize} from '../../infrastructure/localization';

export default class RegisterSubmitButton extends LoginComponent {

    constructor(props) {
        super(props);
    }

    get submitText() {
        return this.isPromo
            ? localize('forms.register.submit-promo')
            : localize('forms.register.submit');
    }

    get error() {
        return this.state.loginModel.validation.errors.submitError;
    }

    render() {
        return (
            <div className="btn-submit-placeholder">
                <div className="submit-error">{this.error}</div>
                <button type="submit" className="btn btn-submit"
                        data-gaeventcategory={this.state.paramModel.tracking.ga.getStartedButton.category}
                        data-gaeventaction={this.state.paramModel.tracking.ga.getStartedButton.action}>
                    {this.submitText}
                </button>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/form-components/register-submit-button.jsx
 **/